module.exports = __webpack_public_path__ + "img/fna.387e64f6.png";